<template>
  <div class="card">
    <div class="card-body">
      <section v-if="fetchError">
        <h2>There was an error loading the story</h2>
      </section>
      <section v-else>
        <div class="text-center mb-4">
          <h1>{{fetchedStory.title}}</h1>
          <div class="storyDetails">Created by {{fetchedStory.authorName}} on <a :href="`https://twitch.tv/${fetchedStory.channelName}`" target="_blank">{{fetchedStory.channelName}}'s</a> channel</div>
        </div>
          <div class="paragraphsContainer rounded">
            <p v-for="(paragraph, index) in paragraphs" :key="index">
              {{paragraph.content}}
            </p>
          </div>
      </section>
      <div class="text-center mt-4 mb-4">
      <audio controls v-if="filePath">
        <source :src="filePath" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Story',
  data () {
    return {
      fetchedStory: {},
      fetchError: false
    }
  },
  created(){
    this.getStory()
  },
  computed:{
        paragraphs(){
      if(this.fetchedStory.paragraphs){
      return {..._.sortBy(this.fetchedStory.paragraphs, ['createdAt'])};
      } else {
        return {}
      }
    },
    filePath(){
      return 'https://s3.amazonaws.com/streamtales-production/'+this.fetchedStory.channelId+'/'+this.fetchedStory.storyId+'/'+Math.max.apply(null,Object.keys(this.fetchedStory.paragraphs))+'.mp3'
    }
  },
  methods: {
    getStory(){
      this.fetchError = false
      var self = this
      axios.get('https://kyo8gp1eu5.execute-api.us-east-1.amazonaws.com/production/story/'+this.$route.params.storyid, {
      }).then(function (response) {
        console.log(response.data)
        self.fetchedStory=response.data
      })
      .catch(function(error){
        console.log(error)
        self.fetchError = true
      }).then(function(){

      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.paragraphsContainer{
    width: 550px;
    margin: 0 auto;

    font-size: 18px;
}
.paragraphsContainer p {
    padding: 20px;
    background: #fbf8ed;
    margin-bottom: 5px;
    border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/Story.vue